module.exports = __webpack_public_path__ + "img/duck.3444c876.png";